import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const PricingEmailValidation = yup.object().shape({
    emails: yup.array().of(yup.string().email(ERRORS.email).required(ERRORS.required)),
    instanceId: yup.string().required(ERRORS.required),
});
